import React, { useState, useEffect } from 'react';
import { Toast as BootstrapToast } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCheckCircle, 
  faExclamationCircle, 
  faInfoCircle 
} from '@fortawesome/free-solid-svg-icons';

interface ToastProps {
  id: string;
  message: string;
  type: 'success' | 'danger' | 'warning' | 'info' | 'primary';
  onClose: () => void;
  autohide?: boolean;
  delay?: number;
}

const Toast: React.FC<ToastProps> = ({ 
  id, 
  message, 
  type, 
  onClose, 
  autohide = true, 
  delay = 3000 
}) => {
  const [show, setShow] = useState<boolean>(true);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (autohide) {
      timer = setTimeout(() => {
        setShow(false);
      }, delay);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [autohide, delay]);

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      onClose();
    }, 300); // Give time for animation to complete
  };

  // Determine icon based on type
  const icon = type === 'success' ? faCheckCircle 
            : type === 'danger' ? faExclamationCircle 
            : faInfoCircle;

  // Determine background color based on type
  const bgColor = `bg-${type}`;
  
  return (
    <BootstrapToast 
      id={id}
      show={show} 
      onClose={handleClose}
      className={`${bgColor} text-white`}
      delay={delay}
      autohide={autohide}
    >
      <BootstrapToast.Header className={`${bgColor} text-white`}>
        <strong className="me-auto">Notification</strong>
        <button 
          type="button" 
          className="btn-close btn-close-white" 
          onClick={handleClose}
          aria-label="Close"
        />
      </BootstrapToast.Header>
      <BootstrapToast.Body>
        <div className="d-flex align-items-center">
          <FontAwesomeIcon icon={icon} className="me-2" />
          {message}
        </div>
      </BootstrapToast.Body>
    </BootstrapToast>
  );
};

export default Toast;
